import {
  Button,
  SuitabilityBadge,
  TableBody,
  Text,
  Tooltip,
  HStack,
  VStack,
} from '@genial/components';
import React from 'react';

import { TableItemProps } from '../models';

import { CustomerBlockStatus } from './components/CustomerBlockStatus';
import { IconCustomerList } from './components/IconCustomerList';

const MobileTableItemBase = ({ customerCaption, handleSelectCustomer, item }: TableItemProps) => {
  return (
    <TableBody testId={`table-customer-body-${item.cpfCnpjFormatted}`} height={192}>
      <VStack p="inline.xxs" space="inline.xxxs" flex={1}>
        <HStack alignItems="center" justifyContent="space-between">
          <VStack>
            <Text variant="semibold" color="neutral.darkest">
              {item.name}
            </Text>
            <Text fontSize="xs" color="neutral.dark">
              Conta de Custódia {item.custodyAccountNumber}
            </Text>
          </VStack>
          <HStack alignItems="center" space="inline.nano">
            {customerCaption.length > 0 && <IconCustomerList icons={customerCaption} isTooltip />}
            <Tooltip testId="qa" label={item.suitabilityProfileName || ''}>
              <SuitabilityBadge label={item.suitabilityProfileName} hideText />
            </Tooltip>
          </HStack>
        </HStack>
        <VStack space="stack.nano">
          <HStack justifyContent="space-between" alignItems="center">
            <Text color="neutral.black">CPF/CNPJ</Text>
            <Text color="neutral.black">{item.cpfCnpjFormatted}</Text>
          </HStack>
          <HStack justifyContent="space-between" alignItems="center">
            <Text color="neutral.black">Cadastro</Text>
            <CustomerBlockStatus customer={item} />
          </HStack>
        </VStack>
        <HStack alignItems="center" space="inline.nano" justifyContent="space-between">
          <VStack>
            <Text color="neutral.black">Saldo disponível</Text>
            <Text variant="semibold" fontSize="lg" color="neutral.black">
              {item.availableBalance}
            </Text>
          </VStack>
          <Button
            testID="table-customer-button-select-customer"
            onPress={handleSelectCustomer}
            isDisabled={item.registrationBlocked}>
            {item.buttonSelectCustomer}
          </Button>
        </HStack>
      </VStack>
    </TableBody>
  );
};

export const MobileTableItem = React.memo(MobileTableItemBase);
